import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToolbarService } from 'app/app-wrapper/toolbar.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    host: {
        class: 'toolbar'
    },
    imports: [
        CommonModule
    ]
})

export class AppToolbarComponent {

    constructor(
        public toolbarService: ToolbarService
    ){

    }
}
